(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-casino/views/no-widgets-message.js') >= 0) return;  svs.modules.push('/modules/lb-casino/views/no-widgets-message.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lb_casino=_svs.lb_casino||{};
_svs.lb_casino.templates=_svs.lb_casino.templates||{};
svs.lb_casino.templates.no_widgets_message = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"components-casino-placeholder-placeholder"),depth0,{"name":"components-casino-placeholder-placeholder","hash":{"information":"På grund av hög belastning så har det gått lite snett. Medans vi fixar det så hittar du spelen via kategorierna.","title":"Oj då, nu gick det snett","iconSize":700,"icon":"casino"},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['svs-lb_casino-no_widgets_message'] = svs.lb_casino.templates.no_widgets_message;
})(svs, Handlebars);


 })(window);